export default "__VITE_ASSET__CRczQLMe__"